/* Footer newsletter.
   Shopify Spam protection (hCaptcha) sends the submit through a /challenge hop,
   so a reliable AJAX submit is impossible and the post-submit redirect comes
   back WITHOUT our query/anchor and WITHOUT a guaranteed ?view= variant.

   Strategy (all native submit, no preventDefault):
   1. On submit, remember the active home view in localStorage. This survives
      the /challenge round-trip.
   2. When we land back on the homepage, restore the right view if Shopify
      dropped it, reveal the "Thank you" message, and scroll to the newsletter
      block via the #newsletter anchor (native scroll, re-applied on load to
      survive late layout shifts from images above the footer). */
(function () {
  var PENDING = 'nlPending';     // "<view>|<timestamp>" recorded at submit time
  var SHOW = 'nlShowSuccess';    // set just before a view-restoring bounce
  var ANCHOR = 'newsletter';
  var TTL = 5 * 60 * 1000;       // ignore a stale pending submit after 5 min

  var path = window.location.pathname;
  var isHome = path === '/';
  var isChallenge = path.indexOf('/challenge') === 0;

  // Keep the browser from restoring the old scroll position over our anchor.
  if ('scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }

  function currentView() {
    return new URLSearchParams(window.location.search).get('view') || '';
  }

  function reveal() {
    document.querySelectorAll('form.js-newsletter').forEach(function (form) {
      var row = form.querySelector('.fc-news__form, .fw-news__form');
      var success = form.querySelector('.js-newsletter-success');
      if (row) row.hidden = true;
      if (success) success.hidden = false;
    });
  }

  function scrollToBlock() {
    var block = document.getElementById(ANCHOR);
    if (block) block.scrollIntoView({ block: 'center' });
  }

  // Strip #newsletter from the address bar once scrolling is done
  // (replaceState — no reload, no Angular route/hashchange trigger).
  function cleanHash() {
    if (window.location.hash === '#' + ANCHOR && history.replaceState) {
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } catch (e) {}
    }
  }

  // Reveal the message and make sure the newsletter block is in view.
  // AngularJS / Brizy on this site scroll to the top during their own init,
  // AFTER our code runs — so we re-apply the scroll a few times post-load to
  // win that race instead of relying on a single attempt or the URL anchor.
  function revealAndScroll() {
    reveal();
    scrollToBlock();
    window.addEventListener('load', function () {
      scrollToBlock();
      setTimeout(scrollToBlock, 300);
      setTimeout(scrollToBlock, 800);
      setTimeout(function () { scrollToBlock(); cleanHash(); }, 1500);
    });
  }

  function readPending() {
    try {
      var raw = localStorage.getItem(PENDING);
      if (!raw) return null;
      var parts = raw.split('|');
      var ts = parseInt(parts[1], 10);
      if (!ts || (Date.now() - ts) > TTL) {
        localStorage.removeItem(PENDING);
        return null;
      }
      return parts[0]; // active view at submit time ('' for landing)
    } catch (e) {
      return null;
    }
  }

  function clearPending() {
    try { localStorage.removeItem(PENDING); } catch (e) {}
  }

  // Record the active view right before the (native) submit fires.
  function bind() {
    document.querySelectorAll('form.js-newsletter').forEach(function (form) {
      form.addEventListener('submit', function () {
        if (!isHome) return;
        try {
          localStorage.setItem(PENDING, currentView() + '|' + Date.now());
        } catch (e) {}
      });
    });
  }

  function handleReturn() {
    if (isChallenge) return; // hCaptcha page — wait, keep the pending flag

    // We bounced back to the correct view to show the message here.
    var flagged = false;
    try { flagged = localStorage.getItem(SHOW) === '1'; } catch (e) {}
    if (flagged) {
      try { localStorage.removeItem(SHOW); } catch (e) {}
      revealAndScroll();
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var posted = params.has('customer_posted') || params.has('contact_posted');
    var pending = readPending();

    if (!pending && !posted) return; // not returning from a submit

    if (!isHome) {
      // Other pages keep their own path; the server already shows the message.
      clearPending();
      return;
    }

    var wantView = pending !== null ? pending : currentView();
    clearPending();

    // Shopify dropped the view: bounce to the right one (anchor → native scroll),
    // carrying the flag so the message is revealed after the reload.
    if (wantView !== currentView()) {
      try { localStorage.setItem(SHOW, '1'); } catch (e) {}
      window.location.replace('/?view=' + encodeURIComponent(wantView) + '#' + ANCHOR);
      return;
    }

    // Already on the right view (or Shopify preserved it through the challenge).
    revealAndScroll();
  }

  function init() {
    bind();
    handleReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
